import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import ThemeToggle from './components/ThemeToggle';
import Solutions from './components/Solutions';
import Contact from './components/Contact';
import Footer from './components/Footer';
import About from './components/About';
import Staff from './components/Staff';
import Blog from './components/Blog';
import Press from './components/Press';
import HelpCenter from './components/HelpCenter';
import PrivacyPolicy from './components/PrivacyPolicy';
import Terms from './components/Terms';
import Home from './components/Home';
import NotFound from './components/NotFound';

const App = () => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    if (savedTheme === 'dark' || (!savedTheme && systemPrefersDark)) setDarkMode(true);
  }, []);

  useEffect(() => {
    if (darkMode) document.body.classList.add('dark');
    
    else document.body.classList.remove('dark');

    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  const particlesRef = useRef(null);

  useEffect(() => {
    const initParticles = (container) => {
      if (!container) return;

      container.innerHTML = '';
      const count = 30;

      for (let i = 0; i < count; i++) {
        const particle = document.createElement('div');
        particle.classList.add('particle');
        const size = Math.random() * 8 + 2;
        const posX = Math.random() * container.offsetWidth;
        const duration = Math.random() * 30 + 15;
        const delay = Math.random() * -30;
        const color = `hsl(${Math.random() * 60 + 200}, 80%, 65%)`;
        const opacity = Math.random() * 0.4 + 0.1;

        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        particle.style.left = `${posX}px`;
        particle.style.background = color;
        particle.style.opacity = opacity;
        particle.style.animation = `float ${duration}s linear ${delay}s infinite`;
        particle.style.position = 'absolute';
        particle.style.borderRadius = '50%';
        particle.style.filter = 'blur(1px)';
        container.appendChild(particle);
      }
    };

    const animateOnScroll = () => {
      const elements = document.querySelectorAll('.animate');
      const windowHeight = window.innerHeight;

      elements.forEach(element => {
        const elementPosition = element.getBoundingClientRect().top;
        const offset = 100;

        if (elementPosition < windowHeight - offset) {
          element.style.opacity = '1';
          element.style.transform = 'translateY(0)';
        }
      });
    };

    initParticles(particlesRef.current);
    animateOnScroll();
    window.addEventListener('scroll', animateOnScroll);

    return () => window.removeEventListener('scroll', animateOnScroll);
  }, []);

  return (
    <div className='min-h-screen font-manrope text-gray-900 bg-gray-50 dark:bg-gray-900 dark:text-gray-200 transition-all duration-300'>
      <Header />
      <ThemeToggle darkMode={darkMode} setDarkMode={setDarkMode} />
      <div ref={particlesRef} className='particles absolute inset-0 z-0 pointer-events-none'></div>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/solutions' element={<Solutions />} />>
        <Route path='/contact' element={<Contact />} />
        <Route path='/about' element={<About />} />
        <Route path='/staff' element={<Staff />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/press' element={<Press />} />
        <Route path='/help-center' element={<HelpCenter />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/terms' element={<Terms />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
